const careerPk = {
  breadcrumbs: { home: 'ہوم', career: 'کیریئر' },
  hero: {
    title: 'اپنے خوابوں کا کیریئر شروع کریں',
    subtitle: 'گرامین بازار میں شامل ہوں اور بنگلہ دیش کے دیہی تجارت کو ڈیجیٹل دور میں لانے میں مدد کریں'
  },
  companyStats: [
    { value: '500+', label: 'ملازمین' },
    { value: '10+', label: 'دفاتر' },
    { value: '98%', label: 'ملازمین کی اطمینان' },
    { value: '100+', label: 'ٹریننگ پروگرامز' }
  ],
  jobsSection: { title: 'خالی آسامیاں', subtitle: 'ہمارے ساتھ کام کریں اور اپنے کیریئر کو آگے بڑھائیں' },
  labels: {
    featured: 'نمایاں',
    postedSuffix: 'شائع',
    salary: 'تنخواہ',
    deadline: 'درخواست کی آخری تاریخ'
  },
  buttons: {
    viewDetails: 'تفصیل دیکھیں',
    apply: 'درخواست دیں',
    cancel: 'منسوخ',
    submit: 'درخواست جمع کریں',
    contact: 'رابطہ کریں'
  },
  cta: {
    title: 'موزوں آسامی نہیں ملی؟',
    subtitle: 'ہم سے رابطہ کریں۔ ہم آپ کو نئی مواقع کے بارے میں آگاہ کریں گے۔',
    contact: 'رابطہ کریں'
  },
  form: {
    titleSuffix: ' - درخواست فارم',
    name: 'نام',
    email: 'ای میل',
    phone: 'فون',
    education: 'تعلیمی قابلیت',
    experience: 'کام کا تجربہ',
    uploadResume: 'رزومے اپلوڈ کریں (PDF, DOC, DOCX)'
  },
  snackbar: { success: 'آپ کی درخواست جمع کر دی گئی ہے۔ ہم جلد رابطہ کریں گے۔' }
};

export default careerPk;


